import { IdentifierWithChildren } from "../factories/waardelijst";
import { DocumentMetadata, Identifier } from "../models";
import { PUBLICATIE_STATUS } from "../models/document-metadata";
import { ICategoryList } from "../ui/interfaces/CategoryList";
import { ICheckbox } from "../ui/interfaces/Checkbox";

export const isPublished = (meta: DocumentMetadata): boolean => {
  const {
    document: { pid },
  } = meta;

  if (!pid) return false;

  return matchStatus(meta, PUBLICATIE_STATUS.gepubliceerd);
};

export const matchStatus = (meta: DocumentMetadata, status: string): boolean => {
  return meta.plooiIntern?.publicatiestatus?.includes(status) ?? false;
};

export const categoryListToIdentifier = (categories: ICategoryList[]): Identifier[] => {
  let returnValue: Identifier[][] = categories.map((categoryList: ICategoryList) => {
    let values: Identifier[] = categoryList.options.map((optie: ICheckbox) => {
      return { id: optie.id, label: optie.label } as Identifier;
    });

    if (categoryList.sublist && categoryList.sublist.length > 0)
      values = values.concat(categoryListToIdentifier(categoryList.sublist));

    return values;
  });

  return returnValue.flat();
};

export const identifierMetChildrenToIdentifier = (lijst: IdentifierWithChildren[]): Identifier[] => {
  let returnValue: Identifier[][] = lijst.map((optie: IdentifierWithChildren) => {
    let values: Identifier[] = [];
    if (optie.children && optie.children.length > 0)
      values = values.concat(identifierMetChildrenToIdentifier(optie.children));
    else values = [{ id: optie.id, label: optie.label }];
    return values;
  });
  return returnValue.flat();
};
